<template>
  <exception />
</template>

<script>
import exception from '@/common/exception';
export default {
  name: 'NotFound',
  components: {
    exception
  }
};
</script>
